/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { EmberChangeset } from "ember-changeset";
/**
 * This component manages two types of data depending of the simple selection or
 * the multiple selection.
 *
 * - A single selection manage a string
 * - A multiple selection manage an array of strings.
 *
 * It can used using a changeset or as a classic component with an
 * `onChange` callback and `selected` attribute.
 */
let ChangesetDropdownComponent = (_class = class ChangesetDropdownComponent extends Component {
  onChange(value) {
    this.args.changeset.set(this.args.propertyName, value);
    this.args.onChangesetUpdate?.(this.args.changeset);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
export { ChangesetDropdownComponent as default };